import json from '../version.json';
import safeStorage from './safeStorage';

// The one place that says which headers a JSON request to the TGM API carries (PANEL-1555).
// Eleven hand-copied blocks used to add `Access-Control-Allow-Methods`/`-Headers`/`-Credentials`
// as well: those are RESPONSE headers, a browser ignores them on a request, and each one only
// lengthened the CORS preflight's Access-Control-Request-Headers list.
export const jsonHeaders = () => ({ 'Content-Type': 'application/json' });

// How long any JSON request to the TGM API may hang before it fails: the shared instance in
// actions/api.js and the bare-axios calls built from the configs below (login, translations, the
// survey-status callback) all use it, so a stalled request ends in the caller's error path
// (CO-BARE-AXIOS-TIMEOUT). Uploads set their own, longer limit.
export const API_TIMEOUT_MS = 30000;

export const jsonRequestConfig = () => ({ headers: jsonHeaders(), timeout: API_TIMEOUT_MS });

// `token` is used as given (an undefined token still yields "Bearer undefined", as every copy did).
export const bearerRequestConfig = token => ({
  headers: { ...jsonHeaders(), Authorization: `Bearer ${token}` },
  timeout: API_TIMEOUT_MS,
});

// Identification the backend reads on a signed-in request (a mismatched X-Client-Version is what
// answers 409 NEW_APP_VERSION). `window.setTempUIVersion` stores an override for testing a UI
// version; the string 'null' and '' mean "no override".
export const clientHeaders = () => {
  const tempVer = safeStorage.getItem('set-temp-UIVersion');
  return {
    'X-Client-Version': tempVer && tempVer !== 'null' ? tempVer : json.version,
    'X-Client-Type': 'web',
    'X-Client-Platform': 'web',
  };
};

const hasHeader = (headers, name) =>
  Object.keys(headers).some(key => key.toLowerCase() === name.toLowerCase());

// Adds the CURRENT session to a request's headers: the token is read from localStorage on every
// call, so a login or the hourly token refresh in Header takes effect on the next request instead
// of after a page reload (CO-TOKEN-SNAPSHOT). An Authorization the caller set explicitly wins.
export const applySessionHeaders = headers => {
  const token = (safeStorage.getItem('auth_token') || '').trim();
  if (!token) return headers;
  if (!hasHeader(headers, 'Authorization')) headers.Authorization = `Bearer ${token}`;
  Object.assign(headers, clientHeaders());
  return headers;
};
